import { Chip, HStack, useCss } from '@nettbureau/vibrant-ui';
import { useContext } from 'react';
import { ContainerContent } from '../container/ContainerContent';
import { ContainerTitle } from '../container/ContainerTitle';
import {
  ContainerWithTheme,
  FeaturedContainer,
} from '../container/FeaturedContainer';
import { ConfigContext } from '../provider/config-provider';
import { Location } from '../sections/LocationSection';
import { getTheme, getTokenFromVibrant } from '../theme';

export interface LocationPickerProps {
  title: string;
  locations: Location[];
}

export function LocationPicker({ locations, title }: LocationPickerProps) {
  const { theme } = useContext(ConfigContext);

  const chipStyles = useCss((input) => {
    return {
      background: getTokenFromVibrant(
        getTheme(theme).districtPicker.chip.backgroundColor,
        input.theme,
      ),
    };
  });

  const linkStyles = useCss((input) => {
    return {
      color: getTokenFromVibrant(
        getTheme(theme).districtPicker.chip.textColor,
        input.theme,
      ),
    };
  });

  return (
    <ContainerWithTheme>
      <FeaturedContainer>
        <ContainerTitle alignment="center" title={title} />
        <ContainerContent>
          <HStack justify="center" maxWidth={150} wrap gap="lg">
            {locations.map(({ name, href }, key) => {
              return (
                <Chip css={chipStyles} size="sm" key={key}>
                  {href ? (
                    <a css={linkStyles} href={href}>
                      {name}
                    </a>
                  ) : (
                    <>{name}</>
                  )}
                </Chip>
              );
            })}
          </HStack>
        </ContainerContent>
      </FeaturedContainer>
    </ContainerWithTheme>
  );
}
